import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { IntegrationsBar } from './components/IntegrationsBar';
import { Features } from './components/Features';
import { HowItWorks } from './components/HowItWorks';
import { DualCTA } from './components/DualCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-slate-950 text-slate-100 font-sans selection:bg-indigo-500/30" data-id="element-0">
      <Navbar data-id="element-1" />

      <main data-id="element-2">
        <Hero data-id="element-3" />
        <IntegrationsBar data-id="element-4" />
        <Features data-id="element-5" />
        <HowItWorks data-id="element-6" />

        <DualCTA data-id="element-7" />
      </main>

      <Footer data-id="element-8" />
    </div>;
}